var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.orders['2020_6']),function(value,key){return _c('div',[_vm._v("\n    "+_vm._s(key)+"\n    "),(_vm.users && _vm.users[key])?_c('span',[_vm._v(_vm._s(_vm.users[key].first_name)+" "+_vm._s(_vm.users[key].last_name))]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-461e0d18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Labels.vue
// module id = null
// module chunks = 